import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getUserProfileThunk } from '../../../common/category/store/thunk'
import { Element } from '../../../common/html/element'
import PopupBusinessConcierge from '../businessConciergeService/PopupBusinessConcierge'
import classes from './index.module.scss'
import './lang/i18n'
import { SearchIntroduction } from './searchIntroduction'
import { SearchResults } from './searchResults'

export const InternationalSearch = () => {
  const dispatch = useDispatch()
  const locale = useSelector((state) => state.i18n.locale)

  useEffect(() => {
    dispatch(getUserProfileThunk())
  }, [locale])

  return (
    <Element className="w100 h100" style={{ backgroundColor: '#e5e5e5' }}>
      <div
        className={[
          'h100 mxAuto dFlex justifyContentBetween',
          classes.internationalSearchContainer,
        ].join(' ')}
      >
        <Element
          className={classes.contentLeft}
          style={{ backgroundColor: '#fff' }}
        >
          <div className={classes.contentLeftContainer}>
            <SearchResults />
          </div>
        </Element>
        <div className={classes.contentRight}>
          <SearchIntroduction />
        </div>
      </div>
      <PopupBusinessConcierge />
    </Element>
  )
}
